// extracted by mini-css-extract-plugin
module.exports = {"AdditionalProfitTable":"styles_AdditionalProfitTable__3BbYq"};